import React from 'react'
// libs
import { Field } from 'redux-form'
// types
import { SwatchesPicker } from 'react-color'
import { WrappedFieldProps } from 'redux-form/lib/Field'
import { SwatchesPickerProps } from 'react-color/lib/components/swatches/Swatches'

interface Props extends Omit<SwatchesPickerProps, 'height' | 'ref' | 'onChange'> {
  name: string
  initialColor: string
}

const renderComponent = ({ input, initialColor, ...props }: Props & WrappedFieldProps) => {
  return (
    <SwatchesPicker
      width={'100%' as any}
      height={'100%' as any}
      color={input.value || initialColor}
      onChangeComplete={input.onChange}
      {...props}
    />
  )
}

const ReduxColorSelect: React.FC<Props> = (props) => <Field {...props} component={renderComponent} />

export default ReduxColorSelect
